// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.weak-set.from.js
// module id = 1390
// module chunks = 168707334958949